//import ENV from '../../env-prod';
// import ENV from '../../env-staging';

const libFirebase = require('firebase');
require('firebase/firestore');

class Firebase {
  static init() {
    Firebase.app = libFirebase.initializeApp(Firebase.getConfig());
  }

  static instance() {
    if (!Firebase.app) {
      Firebase.init();
    }

    return Firebase.app;
  }

  static getConfig() {
    return {
      apiKey: "AIzaSyAeeqvYyh19ddwVyt9JB2IyhjTLFm0MjRg",
      authDomain: "travelaam-b2b.firebaseapp.com",
      databaseURL: "https://travelaam-b2b.firebaseio.com",
      projectId: "travelaam-b2b",
      storageBucket: "travelaam-b2b.appspot.com",
      messagingSenderId: "399899475241"
    };
  }

  static getClient() {
    return libFirebase;
  }

  static database() {
    return Firebase.instance().database();
  }

  static firestore() {
    return Firebase.instance().firestore();
  }

  static storage() {
    return Firebase.instance().storage();
  }

  static auth() {
    return Firebase.instance().auth();
  }
}

export default Firebase.instance();



// WEBPACK FOOTER //
// ./src/lib/Firebase.js